import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Items from "@/pages/Items";
import Quotations from "@/pages/Quotations";
import Orders from "@/pages/Orders";
import OrderForm from "@/pages/OrderForm";
import DeliveryOrders from "@/pages/DeliveryOrders";
import DeliveryOrderDetail from "@/pages/DeliveryOrderDetail";
import Invoices from "@/pages/Invoices";
import PaymentClaims from "@/pages/PaymentClaims";
import ProjectFunds from "@/pages/ProjectFunds";
import Bills from "@/pages/Bills";
import Payroll from "@/pages/Payroll";
import Leave from "@/pages/Leave";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Users from "@/pages/Users";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Expenses from "@/pages/Expenses";
import Loans from "@/pages/Loans";
import Attendance from "@/pages/Attendance";
import Suppliers from "@/pages/Suppliers";
import PurchaseOrders from "@/pages/PurchaseOrders";
import RequestForQuotations from "@/pages/RequestForQuotations";
import SoftwareLicences from "@/pages/SoftwareLicences";
import QuotationApprove from "@/pages/QuotationApprove";
import ClientPortal from "@/pages/ClientPortal";
import PoConfirm from "@/pages/PoConfirm";
import PayReport from "@/pages/PayReport";
import CompanyAssets from "@/pages/CompanyAssets";
import RfqPortal from "@/pages/RfqPortal";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/approve/:token" element={<QuotationApprove />} />
              <Route path="/portal/:token" element={<ClientPortal />} />
              <Route path="/po-confirm/:token" element={<PoConfirm />} />
              <Route path="/pay/:token" element={<PayReport />} />
              <Route path="/rfq/:token" element={<RfqPortal />} />
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/clients" element={
                  <ProtectedRoute module="clients"><Clients /></ProtectedRoute>} />
                <Route path="/clients/:id" element={
                  <ProtectedRoute module="clients"><ClientDetail /></ProtectedRoute>} />
                <Route path="/attendance" element={
                  <ProtectedRoute module="attendance"><Attendance /></ProtectedRoute>} />
                <Route path="/inventory" element={
                  <ProtectedRoute module="inventory"><Items /></ProtectedRoute>} />
                <Route path="/quotations" element={
                  <ProtectedRoute module="quotations"><Quotations /></ProtectedRoute>} />
                <Route path="/orders" element={
                  <ProtectedRoute module="orders"><Orders /></ProtectedRoute>} />
                <Route path="/orders/new" element={
                  <ProtectedRoute module="orders"><OrderForm /></ProtectedRoute>} />
                <Route path="/orders/:id" element={
                  <ProtectedRoute module="orders"><OrderForm /></ProtectedRoute>} />
                <Route path="/delivery-orders" element={
                  <ProtectedRoute module="delivery_orders"><DeliveryOrders /></ProtectedRoute>} />
                <Route path="/delivery-orders/:id" element={
                  <ProtectedRoute module="delivery_orders"><DeliveryOrderDetail /></ProtectedRoute>} />
                <Route path="/invoices" element={
                  <ProtectedRoute module="invoices"><Invoices /></ProtectedRoute>} />
                <Route path="/invoices/:id" element={
                  <ProtectedRoute module="invoices"><InvoiceDetail /></ProtectedRoute>} />
                <Route path="/payment-claims" element={
                  <ProtectedRoute module="payment_claims"><PaymentClaims /></ProtectedRoute>} />
                <Route path="/expenses" element={
                  <ProtectedRoute module="expenses"><Expenses /></ProtectedRoute>} />
                <Route path="/loans" element={
                  <ProtectedRoute module="loans"><Loans /></ProtectedRoute>} />
                <Route path="/project-funds" element={
                  <ProtectedRoute module="project_funds"><ProjectFunds /></ProtectedRoute>} />
                <Route path="/bills" element={
                  <ProtectedRoute module="bills"><Bills /></ProtectedRoute>} />
                <Route path="/payroll" element={
                  <ProtectedRoute module="payroll"><Payroll /></ProtectedRoute>} />
                <Route path="/leave" element={<ProtectedRoute module="leave"><Leave /></ProtectedRoute>} />
                <Route path="/suppliers" element={
                  <ProtectedRoute module="suppliers"><Suppliers /></ProtectedRoute>} />
                <Route path="/rfqs" element={
                  <ProtectedRoute module="rfqs"><RequestForQuotations /></ProtectedRoute>} />
                <Route path="/purchase-orders" element={
                  <ProtectedRoute module="purchase_orders"><PurchaseOrders /></ProtectedRoute>} />
                <Route path="/assets" element={
                  <ProtectedRoute module="company_assets"><CompanyAssets /></ProtectedRoute>} />
                <Route path="/licences" element={
                  <ProtectedRoute module="software_licences"><SoftwareLicences /></ProtectedRoute>} />
                <Route path="/users" element={
                  <ProtectedRoute roles={["admin"]} module="users"><Users /></ProtectedRoute>} />
                <Route path="/settings" element={
                  <ProtectedRoute module="settings"><Settings /></ProtectedRoute>} />
                <Route path="/reports" element={
                  <ProtectedRoute module="reports"><Reports /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
